export default __webpack_public_path__ + "static/media/andouilles.c8f5eafc.jpeg";